import { mString } from 'lib/helpers/utility';

import {
  usePaymentContext,
  usePaymentContextApi
} from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';
import PayOnlineButton from 'components/Payments/payroc/PayOnlineButton';
import Button from 'components/shared/Button/Button';

const Footer = ({ step, amount, onClose }) => {
  const { values } = usePaymentContext();
  const { handlePayment } = usePaymentContextApi();

  const isNewCard = step === 'credit-card';

  return (
    <div className="flex w-full items-center justify-between gap-3">
      <Button
        text={isNewCard ? 'Back' : 'Cancel'}
        variant="tertiary"
        size="small"
        onClick={onClose}
      />
      {!isNewCard && values.methodDetail && (
        <Button text={`Pay ${mString(amount)}`} size="small" onClick={handlePayment} />
      )}

      {isNewCard && <PayOnlineButton className="justify-end" />}
    </div>
  );
};

export default Footer;
